export const toCurrency = (value: number, fractionDigitis = 2) => {
  return (
    'R$ ' +
    value.toFixed(fractionDigitis).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  )
}
